import { DrivingLicenseClass, isForMotorcycle } from "../../model/DrivingLicenseClass";
import { OWN_MOTORCYCLE_PSEUDO_ID, VehicleType } from "../../model/VehicleType";
import { Vehicle } from "../../providers/vehiclesProvider";

export function vehiclesForLicenseClass(
  vehiclesData: Vehicle[],
  bookedTraining?: { drivingLicenseClass: DrivingLicenseClass },
): Array<{ id: string; type: VehicleType }> {
  const vehicles: Array<{ id: string; type: VehicleType }> = [...vehiclesData];
  if (
    bookedTraining?.drivingLicenseClass &&
    isForMotorcycle(bookedTraining.drivingLicenseClass) &&
    vehicles.length === 1
  ) {
    vehicles.unshift({ id: OWN_MOTORCYCLE_PSEUDO_ID, type: "motorcycle" });
  }
  return vehicles;
}
